<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--main" :class="[navbarClasses, footerClasses, {'app-page': isAppPage}]">
    <!-- <vx-tour :steps="steps" v-if="!disableThemeTour" /> -->

    <vx-sidebar :sidebarItems="sidebarItems" :title="siteName" :logo="logoUrl" parent=".layout--main"/>

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">

      <div id="content-overlay"></div>

      <div class="content-wrapper">

        <the-navbar :navbarColor="siteNavbarColor" :class="[{'text-white': isNavbarDark && !isThemeDark}, {'text-base': !isNavbarDark && isThemeDark}]" />

        <div class="router-view">
          <div class="router-content" :class="{'mt-0': navbarType == 'hidden'}">
            <transition :name="routerTransition">
              <div class="router-header flex flex-wrap items-center mb-6" v-if="$route.meta.breadcrumb || $route.meta.pageTitle">
                <div class="content-area__heading" :class="{'pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" />
              </div>
            </transition>
            <div class="content-area__content">
              <back-to-top bottom="5%" visibleoffset="30" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg" />
              </back-to-top>
              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @updateNavbarColor="updateNavbarColor" @updateNavbar="updateNavbar" ></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <the-footer></the-footer>
    </div>
  </div>
</template>

<script>
import VxSidebar from "@/layouts/components/vx-sidebar/VxSidebar.vue";
import TheNavbar from "../components/TheNavbar.vue";
import TheFooter from "../components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import sidebarItems from "@/layouts/components/vx-sidebar/sidebarItems.js";
import BackToTop from "vue-backtotop";
const VxTour = () => import('@/components/VxTour.vue')

export default {
  data() {
    return {
      navbarType : "",//themeConfig.navbarType || "static",
      navbarColor: "",//themeConfig.navbarColor || "#fff",
      footerType: themeConfig.footerType || "static",
      routerTransition: themeConfig.routerTransition || "none",
      isNavbarDark: false,
      //routeTitle: this.$route.meta.pageTitle,
      sidebarItems: sidebarItems,
      disableCustomizer: themeConfig.disableCustomizer,
      windowWidth: window.innerWidth, //width of windows
      hideScrollToTop: themeConfig.hideScrollToTop,
      disableThemeTour: themeConfig.disableThemeTour
    };
  },
  watch: {
    $route() {
      //this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      if (this.navbarColor == "#fff" && val) {
        this.updateNavbarColor("#10163a");
      } else {
        this.updateNavbarColor("#fff");
      }
    }
  },
  computed: {
    routeTitle: function() {
      var pageTitle = this.$route.meta.pageTitle;
      if(pageTitle == 'Maintain Classifications' && this.$siteTypeId() == 1)
        return 'Maintain Grades'
      else if(pageTitle == 'Maintain Module Groups' && this.$siteTypeId() == 1)
        return 'Maintain Terms'
      else if(pageTitle == 'Maintain Courses & Modules' && this.$siteTypeId() == 1)
        return 'Maintain Subjects & Topics'
      else if(pageTitle == 'Maintain Companies' && this.$siteTypeId() == 1)
        return 'Maintain Classrooms'
      else
        return pageTitle
    },
    logoUrl: function() {
      if (localStorage.getItem("userSiteInfo")) {
        if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array){
          return JSON.parse(localStorage.getItem("userSiteInfo"))[0].logoUrl;
        }
        else{ 
          return JSON.parse(localStorage.getItem("userSiteInfo")).logoUrl;
        }
      }
    },
    siteName: function() {
      if (localStorage.getItem("userSiteInfo")) {
        if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array){
          return JSON.parse(localStorage.getItem("userSiteInfo"))[0].name;
        }
        else{ 
          return JSON.parse(localStorage.getItem("userSiteInfo")).name;
        }
      }
    },
    isAppPage() {
      if (this.$route.path.includes("/apps/")) return true;
      else return false;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    siteNavbarColor(){
      var navbarColorValue = "";
      // if(this.navbarColor){
      //   navbarColorValue = this.navbarColor
      // }

      if (localStorage.getItem("userSiteInfo")) {
        if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array){
          navbarColorValue = JSON.parse(localStorage.getItem("userSiteInfo"))[0].navbarColor;
          // if(this.navbarColor){
          //   navbarColorValue = this.navbarColor
          // }
          return navbarColorValue;
        }
        else{ 
          navbarColorValue = JSON.parse(localStorage.getItem("userSiteInfo")).navbarColor;
          // if(this.navbarColor){
          //   navbarColorValue = this.navbarColor
          // }
          return navbarColorValue;
        }
      }
    },
    siteNavbarType(){
      if (localStorage.getItem("userSiteInfo")) {
        if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array){
          return JSON.parse(localStorage.getItem("userSiteInfo"))[0].navbarType;
        }
        else{ 
          return JSON.parse(localStorage.getItem("userSiteInfo")).navbarType;
        }
      }
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.sidebarWidth == "default") return "content-area-default";
      else if (this.sidebarWidth == "reduced") return "content-area-reduced";
      else if (this.sidebarWidth) return "content-area-full";
    },
    navbarClasses() {

      var navbarTypeValue = this.siteNavbarType;
      if(this.navbarType){
        navbarTypeValue = this.navbarType
      }


      return {
        "navbar-hidden": navbarTypeValue== "hidden",
        "navbar-sticky": navbarTypeValue == "sticky",
        "navbar-static": navbarTypeValue == "static",
        "navbar-floating": navbarTypeValue == "floating"
      };

    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static"
      };
    }
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff")
        this.isNavbarDark = false;
      else
        this.isNavbarDark = true;
    },
    updateNavbarColorToggle(val){
      this.navbarColor = val;
      this.isNavbarDark = false;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
        this.$store.dispatch("updateSidebarWidth", "no-sidebar");
        this.disableThemeTour = true;
      } else if (this.windowWidth < 1200) {
        this.$store.dispatch("updateSidebarWidth", "reduced");
      } else {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    }
  },
  components: {
    VxSidebar,
    TheNavbar,
    TheFooter,
    BackToTop,
    VxTour
  },
  created() {
    this.setSidebarWidth();
    if (this.navbarColor == "#fff" && this.isThemeDark) {
      this.updateNavbarColor("#10163a");
    } else {
      this.updateNavbarColor(this.navbarColor);
    }
    if (localStorage.getItem("userSiteInfo")) {
      if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array){
        this.$vs.theme({ primary: JSON.parse(localStorage.getItem("userSiteInfo"))[0].themeColor });
        this.$store.dispatch("updateTheme", JSON.parse(localStorage.getItem("userSiteInfo"))[0].theme);
      }
      else{ 
        this.$vs.theme({ primary: JSON.parse(localStorage.getItem("userSiteInfo")).themeColor });
        this.$store.dispatch("updateTheme", JSON.parse(localStorage.getItem("userSiteInfo")).theme);
      }
    }
  },
  mounted() {
    this.$setColors();
    console.log(
      `%c Nothing to see here... %c`,
      'background:#ef2828; padding: 3px; border-radius: 3px 3px 3px 3px; color: #fff',
      'background:transparent'
    );
  }
};
</script>


